// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consentText {
  background-color: var(--main-bg-color-lighter);
  border: var(--main-border-width) solid var(--main-border-color);
  padding: 1rem;
  margin-bottom: 1rem;
  max-height: 190px;
  overflow-y: auto;
}
.consentText li {
  display: list-item;
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/GDPR/GDPRConsentText.less"],"names":[],"mappings":"AAAA;EACE,8CAAA;EACA,+DAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AACF;AAPA;EASI,kBAAA;AACJ","sourcesContent":[".consentText {\n  background-color: var(--main-bg-color-lighter);\n  border: var(--main-border-width) solid var(--main-border-color);\n  padding: 1rem;\n  margin-bottom: 1rem;\n  max-height: 190px;\n  overflow-y: auto;\n\n  li {\n    display: list-item;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
